import MediaDashboard from '../components/Media/Dashboard/MediaDashboard';

// 媒体平台相关路由
const mediaRoutes = [{ path: '', element: <MediaDashboard /> }];

export default mediaRoutes;
